import { Country } from "../Country.js";
import type { CountrySettings } from "../CountrySettings.js";
import type { Customer } from "../Customer.js";
import { CustomerType } from "../CustomerType.js";
import { getCustomerType } from "./getCustomerType.js";
import { isCountryInEuropeanUnion } from "./isCountryInEuropeanUnion.js";

export function calculateFreeDelivery(
	deliveryCountry: Country,
	weightInGrams: number,
	countrySettings: CountrySettings[],
	customer: Customer | null,
): boolean {
	if (!customer) {
		return false;
	}

	const deliverySettings = countrySettings.find(({ country }) => country === deliveryCountry)?.data?.delivery;

	if (!deliverySettings) {
		throw new Error(`Delivery settings not found for country "${deliveryCountry}"`);
	}

	let freeDeliveryPriceThreshold: number;

	switch (getCustomerType(customer)) {
		case CustomerType.B2c:
			if (deliveryCountry === Country.Czechia) {
				freeDeliveryPriceThreshold = 0.25;
			} else if (isCountryInEuropeanUnion(deliveryCountry)) {
				freeDeliveryPriceThreshold = 0.5;
			} else {
				freeDeliveryPriceThreshold = deliverySettings.freeDeliveryPriceThresholdForRegisteredB2c;
			}
			break;
		case CustomerType.B2b:
			freeDeliveryPriceThreshold = deliverySettings.freeDeliveryPriceThresholdForRegisteredB2b;
			break;
		case CustomerType.B2f:
			freeDeliveryPriceThreshold = deliverySettings.freeDeliveryPriceThresholdForRegisteredB2b;
			break;
	}

	return weightInGrams >= freeDeliveryPriceThreshold * 1000;
}
